<template>
    <div class="notification-header-container">
        <p class="notification-title">{{ title }}</p>
        <div class="notification-settings-container">
            <p class="notificaiton-read-all" @click="handleReadAll">Read All</p>
            <!-- <i class="notificaiton-setting el-icon-setting" @click="handleClickSettings()"></i> -->
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        title() {
            let extraInfo = this.unreadNotificationCount ? `(${this.unreadNotificationCount})` : "";
            return `Notification ${extraInfo}`;
        },
        ...mapGetters([
            "unreadNotificationCount",
        ]),
    },
    methods: {
        handleReadAll() {
            this.$emit("readAllNotification");
        },
        // handleClickSettings() {
        //     this.$_navigateTo({ 'name': 'NotificationSettings' })
        //     this.$emit('handleClickSetttings')
        // }
    },
};
</script>

<style scoped>
.notification-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px 8px 12px;
    color: var(--main-color);
}
.notification-settings-container {
    display: flex;
    align-items: center;
}
.notificaiton-read-all {
    font-size: 14px;
    color: var(--secondary-color-light-blue);
}
.notificaiton-read-all:hover {
    cursor: pointer;
    text-decoration: underline;
}
.notificaiton-setting {
    margin-left: 10px;
    color: var(--secondary-color-light-blue);
}
.notificaiton-setting:hover {
    cursor: pointer;
    text-decoration: underline;
}
.notification-title {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Notification/NotificationHeader.vue